import React, { useEffect, useState, useRef } from "react";
import Sidebar from "../components/Sidebar";
import {
  deleteProduct,
  getProductByID,
  updateProduct,
} from "../actions/productActions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import "../css/records.css";

const ProductScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const productById = useSelector((state) => state.productById);
  const { product } = productById;

  const [confirmed, setConfirmed] = useState(false);
  const timerRef = useRef(null);

  // form inputs state variables
  const [name, setname] = useState("");
  const [description, setdescription] = useState("");
  const [price, setprice] = useState("");
  const [inStock, setinStock] = useState("");
  const [specs, setSpecs] = useState([]);

  const [productType, setproductType] = useState("");
  const [slashPrice, setSlashPrice] = useState("");
  const [category, setCategory] = useState("");
  const [gst, setGST] = useState("");
  const [withoutGST, setWithoutGST] = useState("");

  const adminInfo = useSelector((state) => state.adminInfo);
  const { adminData } = adminInfo;

  const updateProductById = useSelector((state) => state.updateProductById);
  const { updatedProduct } = updateProductById;

  useEffect(() => {
    if (updatedProduct) {
      alert("Product Updated");
    }
  }, [updatedProduct]);

  useEffect(() => {
    if (adminData) {
      if (adminData.accessLevel === "Viewer") {
        navigate("/");
      }
    }
  }, []);

  useEffect(() => {
    dispatch(getProductByID(id));
  }, []);

  useEffect(() => {
    if (product) {
      setname(product.name);
      setdescription(product.description);
      setprice(product.price);
      setinStock(product.inStock);
      setSpecs(product.specs);
      setSlashPrice(product.slashPrice);
      setproductType(product.productType);
      setCategory(product.category);

      setGST(product.gst);
      setWithoutGST(product.withoutGST);
    }
  }, [product]);

  const updatehandler = () => {
    dispatch(
      updateProduct(
        product._id,
        name,
        description,
        productType,
        price,
        slashPrice,
        gst,
        withoutGST,
        inStock,
        category,
        specs
      )
    );
  };

  const deleteHandler = () => {
    if (confirmed) {
      clearTimeout(timerRef.current);
      setConfirmed(false);
	      dispatch(deleteProduct(
    	product._id,
    ))
	alert("Deleted!");
	navigate("/product");
    } else {
      setConfirmed(true);
      alert("Are you sure you want to delete this?");

      const confirmationText = "Are you sure you want to delete this?";
      btnRef.current.textContent = confirmationText;
      timerRef.current = setTimeout(() => {
        setConfirmed(false);
        btnRef.current.textContent = "Delete";
      }, 3000);
    }

  };
  const btnRef = useRef();

  const addFields = () => {
    let newfield = {
      name: "",
      value: "",
    };

    setSpecs([...specs, newfield]);
  };

  return (
    <div className="container-fluid  ps-0">
      <div className="row ">
        <div className="col-lg-2">
          <Sidebar active={3} />
        </div>
        {product && (
          <div
            className="col-lg-10 p-0"
            style={{
              overflowY: "scroll",
              height: "100vh",
            }}
          >
            <div className="records-page">
              <div className="records-header-row d-flex align-items-center justify-content-between flex-wrap">
                <h4 className="records-heading">{product.name}</h4>
                <div className="d-flex" style={{ gap: "0.75em" }}>
                  <button
                    className="btn btn-primary text-light records-action-btn"
                    onClick={updatehandler}
                  >
                    <i class="fa-solid fa-check"></i> Update
                  </button>
                  <button
                    ref={btnRef}
                    onClick={deleteHandler}
                    data-confirm="Are you sure?"
                    role="button"
                    className="btn btn-danger text-light records-action-btn"
                  >
                    <i class="fa-solid fa-trash"></i> Delete
                  </button>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-6 mb-3">
                  <div className="form-card">
                    <h6 className="form-card-title">Product Info</h6>
                    <div class="form-floating mb-3">
                      <input
                        type="text"
                        class="form-control"
                        id="product-name"
                        value={name}
                        onChange={(e) => setname(e.target.value)}
                        placeholder="Name"
                      />
                      <label for="product-name">Name</label>
                    </div>
                    <div class="form-floating mb-3">
                      <textarea
                        value={description}
                        onChange={(e) => setdescription(e.target.value)}
                        className="form-control"
                        style={{
                          height: "150px",
                        }}
                        placeholder="Description"
                        id="product-description"
                      ></textarea>
                      <label for="product-description">Description</label>
                    </div>
                    <div class="form-floating mb-3">
                      <input
                        type="text"
                        class="form-control"
                        id="product-tagline"
                        value={productType}
                        onChange={(e) => setproductType(e.target.value)}
                        placeholder="Tagline"
                      />
                      <label for="product-tagline">Tagline</label>
                    </div>

                    <div className="d-flex" style={{ gap: "0.75em" }}>
                      <div class="form-floating mb-3 w-100">
                        <input
                          type="number"
                          class="form-control"
                          value={price}
                          onChange={(e) => setprice(e.target.value)}
                          id="product-price"
                          placeholder="Price"
                        />
                        <label for="product-price">Price</label>
                      </div>
                      <div class="form-floating mb-3 w-100">
                        <input
                          type="number"
                          value={slashPrice}
                          onChange={(e) => setSlashPrice(e.target.value)}
                          class="form-control"
                          id="product-slash-price"
                          placeholder="Slash Price"
                        />
                        <label for="product-slash-price">Slash Price</label>
                      </div>
                    </div>

                    <div className="d-flex" style={{ gap: "0.75em" }}>
                      <div class="form-floating mb-3 w-100">
                        <input
                          type="number"
                          class="form-control"
                          id="product-gst"
                          placeholder="GST"
                          value={gst}
                          onChange={(e) => setGST(e.target.value)}
                        />
                        <label for="product-gst">GST</label>
                      </div>
                      <div class="form-floating mb-3 w-100">
                        <input
                          type="number"
                          class="form-control"
                          id="product-without-gst"
                          placeholder="Without GST"
                          value={withoutGST}
                          onChange={(e) => setWithoutGST(e.target.value)}
                        />
                        <label for="product-without-gst">Without GST</label>
                      </div>
                    </div>
                    <div className="d-flex" style={{ gap: "0.75em" }}>
                      <div class="form-floating mb-3 w-100">
                        <input
                          type="number"
                          class="form-control"
                          id="product-in-stock"
                          value={inStock}
                          onChange={(e) => setinStock(e.target.value)}
                          placeholder="In Stock"
                        />
                        <label for="product-in-stock">In Stock</label>
                      </div>
                      <div class="w-100">
                        <select
                          onChange={(e) => setCategory(e.target.value)}
                          class="form-select h-100"
                          aria-label="Category"
                        >
                          <option
                            value="bike"
                            selected={category === "bike" && true}
                          >
                            Bike
                          </option>
                          <option
                            value="accessorie"
                            selected={category === "accessorie" && true}
                          >
                            Accessorie
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 mb-3">
                  <div className="form-card">
                    <h6 className="form-card-title">Product Specs</h6>
                    {specs.map((item, i) => (
                      <div key={i}>
                        <div className="d-flex" style={{ gap: "0.75em" }}>
                          <div class="form-floating mb-3 w-100">
                            <input
                              type="text"
                              class="form-control"
                              value={item.name}
                              onChange={(e) => {
                                let data = [...specs];
                                data[i].name = e.target.value;
                                setSpecs(data);
                              }}
                              id={`spec-name-${i}`}
                              placeholder="Spec"
                            />
                            <label for={`spec-name-${i}`}>Spec</label>
                          </div>
                          <div class="form-floating mb-3 w-100">
                            <input
                              type="text"
                              class="form-control"
                              value={item.value}
                              onChange={(e) => {
                                let data = [...specs];
                                data[i].value = e.target.value;
                                setSpecs(data);
                              }}
                              id={`spec-value-${i}`}
                              placeholder="Value"
                            />
                            <label for={`spec-value-${i}`}>Value</label>
                          </div>
                        </div>
                      </div>
                    ))}

                    <button
                      className="btn btn-primary records-icon-btn mx-auto d-block"
                      onClick={addFields}
                      title="Add spec"
                    >
                      <i class="fa-solid fa-plus"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductScreen;
